import React, { ReactElement } from "react";
import { GameState } from "../types";
import { getNextPresident } from "./nextPresident";
import "./TurnOrder.css";

type TurnOrderProps = {
  game: GameState;
  /** The Chancellor nominee, when there is one (during the vote). */
  nominee?: string;
};

/**
 * The seats in turn order, with the President, the nominee and the next President marked, and one
 * sentence saying who is next. Used by the nomination and voting prompts.
 */
export default function TurnOrder(props: TurnOrderProps): ReactElement {
  const game = props.game;
  const next = getNextPresident(game);
  const nomineeIsNext = !!props.nominee && next === props.nominee;

  return (
    <div className="to">
      <ol className="to-order" aria-label="Turn order">
        {game.playerOrder.map((name, index) => {
          const alive = game.players[name].alive;
          let kind = "";
          let label = "";
          if (name === game.president) {
            kind = " to-seat-president";
            label = "President";
          } else if (name === props.nominee) {
            kind = " to-seat-nominee";
            label = "Nominee";
          }
          if (name === next) {
            kind += " to-seat-next";
            label = label ? label + " · next" : "Next president";
          }
          return (
            <li key={name} className={"to-seat" + kind + (alive ? "" : " to-seat-dead")}>
              <span className="to-seat-n">{index + 1}</span>
              <span className="to-seat-name">{name}</span>
              {label && <span className="to-seat-label">{label}</span>}
            </li>
          );
        })}
      </ol>
      {next && (
        <div className={"to-next" + (nomineeIsNext ? " to-next-yes" : "")}>
          {nomineeIsNext
            ? props.nominee + " becomes President next."
            : "Next in turn order: " + next + "."}
        </div>
      )}
    </div>
  );
}
